var MDB = window.MDB || {};
MDB.DPN = MDB.DPN || {};
MDB.DPN.Offers = MDB.DPN.Offers || {};
MDB.DPN.Offers.Settings = MDB.DPN.Offers.Settings || {};

(function($) {
    var BUNDLE_TYPE = 'bundle'
        , MAGAZINE_FLOWTYPE_EXCEPTION = 'MAGAZINE'
        , MAGAZINE_GRID_FIELDS = ['Wbs', 'SalesPromotion', 'AantalLeveringen'];
    
    var deleteProductsPerOfferUrl = document.location.origin + '/api/DPN/Offers/DeleteProductPerOffer',
        crudServiceBaseUrl = document.location.origin + '/api/DPN/Offers/ProductPerOffer',
        promPrkeCrudServiceUrl = document.location.origin + '/api/DPN/Offers/ProductPromPrkes',
        bundlesCrudServiceUrl = document.location.origin + '/api/DPN/Offers/OfferBundles';
    
    var id = $('#Id'),
        activeOffers = $('#active-offers'),
        plannedOffers = $('#planned-offers'),
        expiredOffers = $('#expired-offers'),
        invalidOffers = $('#invalid-offers'),
        offerBundles = $('#offer-bundles'),
        titleSelector = $('#TitleIds'),
        idVal = id.val(),
        enablePrkeFilter = false,
        userHasDeletePermission = false,
        userHasViewInvalidPermission = false,
        _config = undefined;
    
    var viewInvalidRightIdPromise = MDB.Security.validatePermission(MDB.Security.Permissions.DpnOfferSettingsViewInvalid)
        .done(function() {
            userHasViewInvalidPermission = true; 
        })
        .fail(function() {
            userHasViewInvalidPermission = false; 
        });


    $.extend(MDB.DPN.Offers.Settings,
        {
            getTitleName: function(titleIdOrName){
                return MDB.isGuid(titleIdOrName) ?
                  MDB.DPN.Offers.Settings.titleIdToNameMap[titleIdOrName.toUpperCase()] :
                  titleIdOrName;
            },
            getTitleId: function(titleIdOrName){
                return MDB.isGuid(titleIdOrName) ?
                  titleIdOrName :
                  MDB.DPN.Offers.Settings.titleNameToIdMap[titleIdOrName.toUpperCase()];
            },
            isP5Title: function(titleIdOrName){
                //MDB.DPN.Offers.isP5Title uses it's own static id -> name map
                //some of our newer titles may not appear in said map
                return MDB.DPN.Offers.isP5Title(
                  MDB.DPN.Offers.Settings.getTitleName(titleIdOrName)
                );
            },
            isBabTitle: function(titleIdOrName){
                //MDB.DPN.Offers.isBabTitle uses it's own static id -> name map
                //some of our newer titles may not appear in said map
                return MDB.DPN.Offers.isBabTitle(
                    MDB.DPN.Offers.Settings.getTitleName(titleIdOrName)
                );
            },
            isBabMagTitle: function(titleIdOrName){
                //MDB.DPN.Offers.isBabTitle uses it's own static id -> name map
                //some of our newer titles may not appear in said map
                return MDB.DPN.Offers.isBabMagTitle(
                    MDB.DPN.Offers.Settings.getTitleName(titleIdOrName)
                );
            },
            titleIdToNameMap: {},
            titleNameToIdMap: {},
            
            activeProductsPerOfferGrid: function(selector, opts) {
                opts = createGridConfigOpts(opts,
                    true,
                    true,
                    null,
                    moment(),
                    null,
                    userHasDeletePermission,
                    false,
                    false,
                    false);
                return MDB.KendoConfigBuilder.reloadableGrid(selector, createGridConfig(opts));
            },
            plannedProductsPerOfferGrid: function(selector, opts) {
                opts = createGridConfigOpts(opts, true, null, moment().add(1, 'days'), null, null, null, false, false, false);
                return MDB.KendoConfigBuilder.reloadableGrid(selector, createGridConfig(opts));
            },
            expiredProductsPerOfferGrid: function(selector, opts) {
                opts = createGridConfigOpts(opts,
                    userHasViewInvalidPermission,
                    null,
                    null,
                    null,
                    moment().add(-1, 'days'),
                    null,
                    true,
                    false,
                    true);
                return MDB.KendoConfigBuilder.reloadableGrid(selector, createGridConfig(opts));
            },
            invalidProductsPerOfferGrid: function(selector, opts) {
                opts = createGridConfigOpts(opts,
                    userHasViewInvalidPermission,
                    null,
                    null,
                    null,
                    null,
                    null,
                    false,
                    true,
                    true);
                return MDB.KendoConfigBuilder.reloadableGrid(selector, createGridConfig(opts));
            },
            offerBundlesGrid: function(selector, config){
                return MDB.KendoConfigBuilder.reloadableGrid(selector, createBundleGridConfig(config));
            },
            generateOfferDescription: function(context){ 
                var fields = context.find('#regular-settings input,select');
                
                return $.Deferred(function(def){
                    $.ajax({
                        url: '/DPN/Offers/GetOfferDescription',
                        data: fields.serialize()
                    }).success(function(data){
                        data = data || { Success: false };
                        
                        if(!data.Success){
                            if(!data.Errors){
                                data.Errors = [MDB.loadResourceString('OfferService_GetOfferDescription_GenericError_Text')]
                            }
                            
                            def.reject(data.Errors.join('\r\n'));
                            return;
                        }
                        
                        def.resolve(data.Value);
                    }).error(function(){
                        def.reject(MDB.loadResourceString('OfferService_GetOfferDescription_GenericError_Text'));
                    });
                }).promise();
            },
            initSettingsForm: function(context){
                context = $(context || document);

                var isGeneratedDescriptionSelector = context.find('#IsGeneratedDescription')
                    , descriptionSelector = context.find('#Description');
                
                var isGeneratedDescription = function(){
                    return isGeneratedDescriptionSelector.is(':checked');
                };
                
                //Needs to be attached prior to initialising our generated description switch
                //The event seems to not trigger otherwise
                context.find('#regular-settings input,select').on('change', _.debounce(function(){
                    //We should only pull a new description from remote when the 'generate description'
                    //checkbox is enabled
                    if(!isGeneratedDescription()){
                        return;
                    }
                    
                    MDB.UI.Loader.showProgressCursor();
                    
                    MDB.DPN.Offers.Settings.generateOfferDescription(context)
                        .always(function(){
                            MDB.UI.Loader.stopProgressCursor(); 
                        })
                        .fail(function(message){
                            MDB.Notify.bootstrapWarning(message); 
                        })
                        .done(function(description){
                            //Check once again in case of a longer than normal delay
                            if(!isGeneratedDescription()){
                                return;
                            }
                            
                            descriptionSelector.val(description);
                        });
                }, 500));

                //initBootstrapSwitches takes a container, so we select the parent element
                MDB.initBootstrapSwitches(isGeneratedDescriptionSelector.parent(), function(){
                    //Null removes the attribute
                    var attributeValue = isGeneratedDescription() ? 'readonly' : null;
                    descriptionSelector.attr('readonly', attributeValue);
                });

                //Disabled: Bundles grid should only be shown on page load
                //this to prevent adding bundles prior to confirming an offer as type 'bundle'
                //Display our bundles grid only when selected offer type is bundle
                // context.find('#Type').on('change', function(){
                //     offerBundlesContainer.toggleClass(
                //         'hidden',
                //         $(this).val() === BUNDLE_TYPE
                //     );
                // });
            },
            boot: function(config) {
                var args = arguments;
                
            	if(viewInvalidRightIdPromise) {
            		(function(p) {
            			// wrapped in a function call because not every promises implementation 
            			// will handle already resolved promises async.
            			viewInvalidRightIdPromise=null;
                        p.always(function(){
                            MDB.DPN.Offers.Settings.boot.apply(undefined, args);
                        });
            		})(viewInvalidRightIdPromise);
            		
            		//Return early to prevent duplicate instantiation of grids
            		return;
                }

                _config = config;
            	
                MDB.DPN.Offers.setTitlesForSystem('bab', config.babTitles);
                MDB.DPN.Offers.setTitlesForSystem('bab_mag', config.babMagTitles);
            	
                enablePrkeFilter = true;

                var titleOptsArr = titleSelector.find('option').toArray();
                titleOptsArr.forEach(function(optionEl){
                    var id = optionEl.value.toUpperCase();
                    var name = optionEl.innerText.toUpperCase();
                    
                    MDB.DPN.Offers.Settings.titleIdToNameMap[id] = name;
                    MDB.DPN.Offers.Settings.titleNameToIdMap[name] = id;
                });
                
                var combiProductSection = $('.combi-product-section')
                    , combiProductToggle = $('#IncludeCombiProduct')
                    , combiProductDropdownContainer = $('.combi-product-dropdown-container');

                MDB.initBootstrapSwitches(combiProductToggle.parent(), function(){
                    combiProductDropdownContainer.toggleClass('hidden', !this.checked);
                });
                
                $('#DiscountPercentage').keydown(function(e) {
                    var me = $(this);
                    var requirePrice = $('#RequirePrice');

                    if(me.val() == '') {
                        requirePrice.val(true);
                    } else {
                        requirePrice.val(false);
                    }
                });

                $('[name="ChannelIds"]').kendoMultiSelect({
                    autoClose: false,
                    placeholder: MDB.loadResourceString('DPN_Offers_Channelds_KendoMultiSelect_Placeholder'),
                    dataBound: function(e) {
                        matchCheckboxState(e.sender.wrapper);
                    }
                });

                $('[name="SiteIds"]').kendoMultiSelect({
                    autoClose: false,
                    placeholder: MDB.loadResourceString('DPN_Offers_SiteIds_KendoMultiSelect_Placeholder'),
                    dataBound: function(e) {
                        matchCheckboxState(e.sender.wrapper);
                    }
                });

                $('#advanced-settings').removeClass('hidden');

                $('#ExcludeChannels, #ExcludeSites').bootstrapSwitch({
                    onColor: 'danger',
                    offColor: 'success',
                    onText: MDB.loadResourceString('DPN_Offers_MultiselectSwitchLabel_On'),
                    offText: MDB.loadResourceString('DPN_Offers_MultiselectSwitchLabel_Off'),
                    labelWidth: 0,
                    onSwitchChange: function(event, state) {
                        var self = $(this);
                        var multiselectElement = self.closest('.row').find('.k-header');
                        if (state) {
                            multiselectElement.addClass('exclude-selection').removeClass('include-selection');
                        } else {
                            multiselectElement.addClass('include-selection').removeClass('exclude-selection');
                        }
                    }
                });

                // DPN-5155
                // doorlopend (continuous) is a special case, offers with durationunit of doorlopend cannot have a duration assigned to them
                $('#DurationUnit').on('change', function() {
                  var isDoorlopend = this.value === 'doorlopend';
                  var duration = $('#Duration');
  
                  duration.attr('disabled', isDoorlopend);
                  if (isDoorlopend) duration.val(undefined);
                }).trigger('change');

                MDB.DPN.Offers.Settings.initSettingsForm();
                MDB.DPN.Offers.Settings.initDiscountPeriodSettings();

                
                var flowTypeException = $('#FlowTypeException');

                var isMagazineSelected = function(){
                    return flowTypeException.val() === MAGAZINE_FLOWTYPE_EXCEPTION;
                }

                var toggleFlowTypeExceptionBasedFields = function(){
                    var isMagazine = isMagazineSelected();

                    combiProductSection.toggleClass('hidden', !isMagazine);

                    //Ensure our combiProduct toggle is disabled upon deselect
                    if(!isMagazine){
                        combiProductToggle.bootstrapSwitch('state', false);
                    }
                }

                flowTypeException.on('change', toggleFlowTypeExceptionBasedFields);

                //Ensure the proper state is set on load
                toggleFlowTypeExceptionBasedFields();

                if (idVal) {
                    MDB.Security.validatePermission(MDB.Security.Permissions.DpnOffersSettingsDelete)
                        .done(function() {
                            userHasDeletePermission = true; 
                        })
                        .fail(function() {
                            userHasDeletePermission = false; 
                        })
                        .always(function() {
                            var defaultTitle = titleSelector.data('default-title') ||
                                titleSelector.children('option').val();

                            var baseOpts = {
                                availableTitles: '#TitleIds option',
                                id: idVal
                            };

                            var editableOpts = $.extend(true, {}, baseOpts);
                            editableOpts.onChangeSuccess = function() {
                                invalidGrid.reload();
                                inactiveGrid.reload();
                                plannedGrid.reload();
                                grid.reload();
                            };

                            var grid = MDB.DPN.Offers.Settings.activeProductsPerOfferGrid(activeOffers, editableOpts);
                            var plannedGrid =
                                MDB.DPN.Offers.Settings.plannedProductsPerOfferGrid(plannedOffers, editableOpts);
                            var inactiveGrid =
                                MDB.DPN.Offers.Settings.expiredProductsPerOfferGrid(expiredOffers, baseOpts);
                            var invalidGrid =
                                MDB.DPN.Offers.Settings.invalidProductsPerOfferGrid(invalidOffers, baseOpts);
                            
                            //Our bundles grid is a standalone grid, it has no integrations with the rest of our grids
                            MDB.DPN.Offers.Settings.offerBundlesGrid(offerBundles, baseOpts);

                            if (defaultTitle) {
                                grid.data('kendoGrid').addRow();
                            }

                            var toggleFlowTypeExceptionBasedGridFields = function(){
                                //Both show and hide share the same signature; making for an easy 'toggle'
                                var toggleGridFieldsFn = isMagazineSelected() ?
                                    kendo.ui.Grid.prototype.showColumn :
                                    kendo.ui.Grid.prototype.hideColumn;

                                forAllProductsPerOfferGrids(function (grid){
                                    MAGAZINE_GRID_FIELDS.forEach(function(field){
                                        toggleGridFieldsFn.call(grid, field);
                                    });
                                });
                            }
                            
                            if(isMagazineSelected()){
                                //When a magazine is edited; always attempt to properly reflect the current state of the grid until the offer
                                //is actually saved and changes are made final
                                flowTypeException.on('change', toggleFlowTypeExceptionBasedGridFields);
                            }

                            //Only toggle magazine fields on init; protect users against creating rows with potential invalid values
                            toggleFlowTypeExceptionBasedGridFields();
                        });
                }
            }
        });

    function mergeGridConfigOpts(defaultOpts, newOpts) {
        var opts = $.extend(true, {}, defaultOpts || {});
        opts = $.extend(opts, newOpts || {});
        return opts;
    }

    function createGridConfigOpts(opts,
        editable,
        isActive,
        activeFromStart,
        activeFromEnd,
        activeUntil,
        deleteable,
        isExpiredGrid,
        isInvalidGrid,
        restrictEdit) {

        //opts = $.extend(true, {}, opts || {});
        opts = mergeGridConfigOpts(opts,
            {
                //$.extend(opts, {
                deleteable: deleteable,
                editable: editable,
                isActive: isActive,
                activeFromStart: activeFromStart,
                activeFromEnd: activeFromEnd,
                activeUntil: activeUntil,
                isExpiredGrid: isExpiredGrid,
                isInvalidGrid: isInvalidGrid,
                restrictEdit: restrictEdit
            });

        return opts;
    }


    function matchCheckboxState(element) {
        var checkbox = element.closest('.row').find('[name*="Exclude"]');
        if (checkbox.prop('checked')) {
            element.addClass('exclude-selection').removeClass('include-selection');
        } else {
            element.addClass('include-selection').removeClass('exclude-selection');
        }
    }
    
    function createBundleGridConfig(opts) {
        var offerBundlesCrudUrl = bundlesCrudServiceUrl + '?' + $.param({ offerId: opts.id });

        //Our dropdowns are in MVC SelectListItem format
        var prkeDescriptionMap = _config.rowDropDowns.PrkeId.reduce(function(map, dropdownKv){
            map[dropdownKv.Value] = dropdownKv.Text;
            return map;
        }, {});
        
        var titleDropdownOpts = $(MDB.DPN.Offers.getTitleDropdownOptions());
        var prkeDropdownOpts = $(
            MDB.objectToDropdown(_config.rowDropDowns.PrkeId, { valueSelector: 'Value', labelSelector: 'Text' })
        ).find('option');

        //Transform options to lowercase to match kendo casing
        titleDropdownOpts.each(function(){
            this.setAttribute('value', this.getAttribute('value').toLowerCase())
        })
        
        var allStringifiedPrkeValues = _config.rowDropDowns.PrkeId.map(function(dd){ return dd.Value; });
        var allProductIdValues = titleDropdownOpts.map(function(){ return this.value; }).toArray();
        
        var datasourceConfig = {
            transport: {
                read: function(options) {
                    MDB.KendoConfigBuilder.dataSourceTransportFunction(offerBundlesCrudUrl, 'GET', options);
                },
                create: function(options) {
                    MDB.KendoConfigBuilder.dataSourceTransportFunction(
                        offerBundlesCrudUrl,
                        'POST',
                        options
                    );
                },
                update: function(options) {
                    MDB.KendoConfigBuilder.dataSourceTransportFunction(
                        offerBundlesCrudUrl,
                        'PUT',
                        options
                    );
                },
                destroy: function(options){
                    MDB.KendoConfigBuilder.dataSourceTransportFunction(
                        offerBundlesCrudUrl,
                        'DELETE',
                        options
                    );
                }
            },
            pageSize: 20,
            schema: {
                model: {
                    id: 'Id',
                    fields: {
                        Id: { 
                            editable: false, 
                            type: 'number' 
                        },
                        PrkeId: { 
                            editable: !opts.restrictEdit, 
                            type: 'number',
                            defaultValue: function(){
                                //Returned value is stringified
                                return parseInt(findFirstUniquePrkeProductCombo().prkeId);
                            }
                        },
                        ProductId: { 
                            editable: !opts.restrictEdit, 
                            defaultValue: function(){
                                return findFirstUniquePrkeProductCombo().productId;
                            } 
                        }
                    }
                }
            },
            error: function(e) {
                this.cancelChanges();
                alert(MDB.KendoConfigBuilder.getWebApiErrorsMessage(e));
            }
        };
        
        function findFirstUniquePrkeProductCombo()
        {
            var grid = offerBundles.data('kendoGrid');
            
            var productIdsPerPrke = {};
            grid.dataSource.data().forEach(function(dataItem){
                if(!productIdsPerPrke[dataItem.PrkeId]){
                    productIdsPerPrke[dataItem.PrkeId] = [];
                }

                productIdsPerPrke[dataItem.PrkeId].push(dataItem.ProductId);
            });
            
            var productCount = allProductIdValues.length;
            for (var prkeIndex = 0; prkeIndex < allStringifiedPrkeValues.length; prkeIndex++){
                var prkeId = allStringifiedPrkeValues[prkeIndex];
                var productIdsForPrke = productIdsPerPrke[prkeId];
                
                //When prke is not yet used; it can be combined with the first available productId
                if(!productIdsForPrke){
                    return {
                        prkeId: prkeId,
                        productId: allProductIdValues[0]
                    }
                }
                
                //All combinations are in use; this prke can no longer be assigned
                if(productIdsForPrke.length === productCount){
                    continue;
                }
                
                //We should be able to associate one of our products with the current prke
                for (var productIndex = 0; productIndex < allProductIdValues.length; productIndex++){
                    var productId = allProductIdValues[productIndex];

                    //ProductId not yet used in combination with the given PRKE; we can assign this as our default
                    if(productIdsForPrke.indexOf(productId) === -1){
                        return {
                            prkeId: prkeId,
                            productId: productId
                        }
                    }
                }
            }
            
            //In a real life scenario; this should never occur
            //prevent weird errors in our grid by returning at least a pair of valid values
            //our backend will error out when these are used however
            return {
                prkeId: allStringifiedPrkeValues[0],
                productId: allProductIdValues[0]
            }
        }
        
        function renderEditorFor(field, model){
            var grid = offerBundles.data('kendoGrid');

            var editorContainer = grid.element.find('[data-container-for="' + field + '"]');
            var column = grid.options.columns.find(function(c){ return c.field === field });

            column.editor(
                editorContainer,
                {
                    field: field,
                    editor: column.editor,
                    model: model
                }
            )
        }

        return {
            dataSource: new kendo.data.DataSource(datasourceConfig),
            columns: [{
                field: 'PrkeId',
                title: MDB.loadResourceString('ProductPerOfferListEditModel_PRKE_DisplayName'),
                template: function (model) {
                    return prkeDescriptionMap[model.PrkeId];
                },
                editor: function(container, opts){
                    //Even though our default value returns an int;
                    //for new records, kendo might still stringify it
                    opts.model.PrkeId = parseInt(opts.model.PrkeId);
                    
                    var grid = offerBundles.data('kendoGrid');

                    //Clear potential previous editor
                    container.empty();
                    
                    //One product should not be allowed to have the same PrkeId multiple times
                    //Take all selected PrkeIds for our current product and filter those
                    var ignoredPrkeIds = [];

                    grid.dataSource.data().forEach(function(dataItem){
                        if(dataItem.ProductId === opts.model.ProductId && dataItem.PrkeId !== opts.model.PrkeId){
                            //Our PrkeId field is an integer, while our dropdown value is a string
                            ignoredPrkeIds.push(dataItem.PrkeId.toString());
                        }
                    });

                    var availablePrkeDropdownOpts = prkeDropdownOpts.filter(function(){
                        return ignoredPrkeIds.indexOf(this.value) === -1;
                    });
                    
                    return MDB.KendoConfigBuilder.gridDropdownEditor(
                        container,  
                        opts.field,
                        availablePrkeDropdownOpts,
                        {
                            value: opts.model.PrkeId,
                            filter: 'contains',
                            
                            //Update our ProductId dropdown as our PrkeId changed
                            change: function(){
                                opts.model.PrkeId = this.value();
                                renderEditorFor('ProductId', opts.model);
                            }
                        }, 
                        opts
                    );
                }
            }, {
                field: 'ProductId',
                title: MDB.loadResourceString('ProductPerOfferListEditModel_Title_DisplayName'),
                template: function (model) {
                    return MDB.DPN.Offers.Settings.getTitleName(model.ProductId);
                },
                editor: function (container, opts){
                    //Even though our default value returns an int;
                    //for new records, kendo might still stringify it
                    var prkeId = parseInt(opts.model.PrkeId);
                    
                    var grid = offerBundles.data('kendoGrid');
                    
                    //Clear potential previous editor
                    container.empty();
                    
                    //One PRKE should not be allowed to have the same ProductId multiple times
                    //Take all selected productIds for our current PRKE and filter those
                    var ignoredProductIds = [];

                    grid.dataSource.data().forEach(function(dataItem){
                        if(dataItem.PrkeId === prkeId && dataItem.ProductId !== opts.model.ProductId){
                            ignoredProductIds.push(dataItem.ProductId);
                        }
                    });
                    
                    var availableTitleDropdownOpts = titleDropdownOpts.filter(function(){
                        return ignoredProductIds.indexOf(this.value) === -1;
                    });
                    
                    return MDB.KendoConfigBuilder.gridDropdownEditor(
                        container,
                        opts.field,
                        availableTitleDropdownOpts,
                        {
                            value: opts.model.ProductId,
                            
                            //Update our PrkeId dropdown as our ProductId changed
                            change: function(){
                                opts.model.ProductId = this.value();
                                renderEditorFor('PrkeId', opts.model);
                            }
                        },
                        opts
                    );
                }
            }, MDB.KendoConfigBuilder.gridCommandColumn(['edit', 'destroy'])],
            messages: {
                commands: MDB.KendoConfigBuilder.commandLabels(),
                noRecords: MDB.loadResourceString('DataTable_ZeroRecords')
            },
            pageable: MDB.KendoConfigBuilder.gridPageableSettings(),
            editable: 'inline',
            toolbar: ['create'],
            navigatable: true,
            sortable: {mode: 'multiple'},
            scrollable: true
        };
    }

    function createGridConfig(opts) {
        //Hack, clone to and convert values to uppercase, lowercase may or may not break things
        var availableTitles = $(opts.availableTitles)
          .clone()
          .each(function(){ this.value = this.value.toUpperCase(); });
        
        var gridConfig = {
            dataSource: createDataSource(opts),
            columns: [
                {
                    field: 'PRKE',
                    title: MDB.loadResourceString('ProductPerOfferListEditModel_PRKE_DisplayName'),
                    width: MDB.KendoConfigBuilder.extraSmallColumnWidth
                }, {
                    field: 'PROM',
                    title: MDB.loadResourceString('ProductPerOfferListEditModel_PROM_DisplayName'),
                    width: MDB.KendoConfigBuilder.smallColumnWidth
                }, {
                    field: 'Title',
                    title: MDB.loadResourceString('ProductPerOfferListEditModel_Title_DisplayName'),
                    template: function (model) {
                        return MDB.DPN.Offers.Settings.getTitleName(model.Title); 
                    },
                    width: MDB.KendoConfigBuilder.mediumColumnWidth
                }, {
                    field: 'CustomPromPrke',
                    title: MDB.loadResourceString('ProductPerOfferListEditModel_CustomPromPrke_DisplayName'),
                    template: MDB.KendoConfigBuilder.gridBooleanYesNoTemplate('CustomPromPrke'),
                    width: MDB.KendoConfigBuilder.mediumColumnWidth
                }, {
                    field: 'BAN_P5_PROM_ID',
                    title: MDB.loadResourceString('ProductPerOfferListEditModel_BAN_P5_PROM_ID_DisplayName'),
                    editor: MDB.KendoConfigBuilder.emptyEditor,
                    width: MDB.KendoConfigBuilder.mediumColumnWidth
                }, {
                    field: 'BAN_P5_PRKE_ID',
                    title: MDB.loadResourceString('ProductPerOfferListEditModel_BAN_P5_PRKE_ID_DisplayName'),
                    editor: MDB.KendoConfigBuilder.emptyEditor,
                    width: MDB.KendoConfigBuilder.largeColumnWidth
                }, {
                    field: 'UseAriaProductId',
                    title: 'Gebruik ARIA PRKE',
                    template: MDB.KendoConfigBuilder.gridBooleanYesNoTemplate('UseAriaProductId'),
                    width: MDB.KendoConfigBuilder.mediumColumnWidth
                }, {
                    field: 'ARIA_PRODUCT_ID',
                    title: 'ARIA Product',
                    width: MDB.KendoConfigBuilder.mediumColumnWidth
                }, {
                    field: 'PaymentMethod',
                    title: MDB.loadResourceString('ProductPerOfferListEditModel_PaymentMethod_DisplayName'),
                    width: MDB.KendoConfigBuilder.mediumColumnWidth
                }, {
                    field: 'DistributionMethod',
                    title: MDB.loadResourceString('ProductPerOfferListEditModel_DistributionMethod_DisplayName'),
                    width: MDB.KendoConfigBuilder.mediumColumnWidth
                }, {
                    field: 'Description',
                    title: MDB.loadResourceString('ProductPerOfferListEditModel_Description_DisplayName'),
                    width: MDB.KendoConfigBuilder.mediumLargeColumnWidth
                }, {
                    field: 'ExtraDescription',
                    title: MDB.loadResourceString('ProductPerOfferListEditModel_ExtraDescription_DisplayName'),
                    width: MDB.KendoConfigBuilder.mediumLargeColumnWidth
                }, {
                    field: 'ProductPrice',
                    title: MDB.loadResourceString('ProductPerOfferListEditModel_Price_DisplayName'),
                    width: MDB.KendoConfigBuilder.mediumColumnWidth,
                    format: '€ {0:n2}'
                },{
                    field: 'Labels',
                    title: 'Labels',
                    width: MDB.KendoConfigBuilder.mediumColumnWidth,
                    template: function(model){
                        return (model.Labels || []).join(', '); 
                    },
                    editor: function (container, opts) {
                        container.append($('<select />'));
                        
                        var kLabelSelector = MDB.KendoConfigBuilder.extendablebleMultiDropdown(container.find('select'), {
                            change: function () {
                                opts.model.set('Labels', this.value()); 
                            },
                            dataTextField: 'text',
                            dataValueField: 'value',
                            dataSource: MDB.KendoConfigBuilder.arrayDataSource(opts.model.Labels)
                        });
                        
                        kLabelSelector.value(opts.model.Labels);
                    }
                }, {
                    field: 'ActiveFrom',
                    title: MDB.loadResourceString('ProductPerOfferListEditModel_ActiveFrom_DisplayName'),
                    format: '{0:dd/MMM/yyyy}',
                    width: MDB.KendoConfigBuilder.mediumLargeColumnWidth
                }, {
                    field: 'ActiveUntil',
                    title: MDB.loadResourceString('ProductPerOfferListEditModel_ActiveUntil_DisplayName'),
                    format: '{0:dd/MMM/yyyy}',
                    width: MDB.KendoConfigBuilder.mediumLargeColumnWidth
                }, {
                    field: 'IsActive',
                    title: MDB.loadResourceString('ProductPerOfferListEditModel_IsActive_DisplayName'),
                    template: MDB.KendoConfigBuilder.gridBooleanYesNoTemplate('IsActive'),
                    width: MDB.KendoConfigBuilder.smallColumnWidth
                }, {
                    field: 'IsInvalid',
                    title: MDB.loadResourceString('ProductPerOfferListEditModel_IsInvalid_DisplayName'),
                    template: MDB.KendoConfigBuilder.gridBooleanYesNoTemplate('IsInvalid'),
                    width: MDB.KendoConfigBuilder.smallColumnWidth,
                    hidden: !userHasViewInvalidPermission
                }, {
                    field: 'AantalLeveringen',
                    title: MDB.loadResourceString('ProductPerOfferListEditModel_AantalLeveringen_DisplayName'),
                    width: MDB.KendoConfigBuilder.mediumColumnWidth,
                    editor: function(container, opts) {
                        MDB.KendoConfigBuilder.gridTextBoxEditor(
                            container, 
                            opts, 
                            { 'type': 'number' }
                        );
                    }
                }, {
                    field: 'Wbs',
                    title: MDB.loadResourceString('ProductPerOfferListEditModel_Wbs_DisplayName'),
                    width: MDB.KendoConfigBuilder.smallColumnWidth
                }, {
                    field: 'SalesPromotion',
                    title: MDB.loadResourceString('ProductPerOfferListEditModel_SalesPromotion_DisplayName'),
                    width: MDB.KendoConfigBuilder.mediumColumnWidth
                }
            ],
            messages: {
                commands: MDB.KendoConfigBuilder.commandLabels(),
                noRecords: MDB.loadResourceString('DataTable_ZeroRecords')
            },
            navigatable: true,
            sortable: { mode: 'multiple' },
            scrollable: true,
            pageable: MDB.KendoConfigBuilder.gridPageableSettings()
        };
        
        if (opts.editable) {
            gridConfig.toolbar = ['create'];
            gridConfig.editable = 'inline';

            gridConfig.columns.push(MDB.KendoConfigBuilder.gridCommandColumn(['edit']));
            
            var findColumnByField = function(field) {
                return _.find(gridConfig.columns, function(column) {
                    return column.field === field 
                }); 
            };
            
            var promPrkeCache = {};
            
            var banP5PromColumn = findColumnByField('BAN_P5_PROM_ID');
            var banP5PrkeColumn = findColumnByField('BAN_P5_PRKE_ID');
            var titleColumn = findColumnByField('Title');
            var ariaProductIdColumn = findColumnByField('ARIA_PRODUCT_ID');
            var useAriaPrkeColumn = findColumnByField('UseAriaProductId');
            var paymentMethodColumn = findColumnByField('PaymentMethod');
            var distributionMethodColumn = findColumnByField('DistributionMethod');
            
            var getCachedPromPrkeData = function (title, callback) {
                if (promPrkeCache[title]){
                    var cachedItems = promPrkeCache[title];
                    callback(cachedItems.proms,  cachedItems.prkesPerProm);
                    return;
                }
                
                getPromPrkeData(title, function (proms, prkesPerProm) {
                    promPrkeCache[title] = {
                        proms: proms,
                        prkesPerProm: prkesPerProm
                    };

                    callback(proms, prkesPerProm);
                });
            };
            
            var renderBanP5PromPrkeEditor = function (container, opts) {
                var model = opts.model;
                var isProm = opts.field === 'BAN_P5_PROM_ID';
                
                var title = MDB.DPN.Offers.Settings.getTitleId(model.Title);
                
                var currentDropdown = container.find('select[name="' + opts.field + '"]');
                var currentTextBox = container.find('input[type="number"][name="' + opts.field + '"]');
                
                //Remove unused control, recreate when needed
                //Dropdownlist should be removed by kendoWrapper element only when present in DOM
                var controlToRemove = model.CustomPromPrke ? 
                    (currentDropdown.length ? currentDropdown.data('kendoDropDownList').wrapper : currentDropdown) : 
                    currentTextBox;
                
                if (controlToRemove.length) {
                    controlToRemove.remove();
                }
                
                if (model.CustomPromPrke){
                    var isP5Prom = isProm && MDB.DPN.Offers.Settings.isP5Title(model.Title);
                    
                    if (currentTextBox.length && isProm){
                        var requiredReadonlyStatus = MDB.DPN.Offers.Settings.isP5Title(model.Title) ? 'readonly' : undefined;
                        
                        //Textbox should be editable but is not, recreate
                        if (requiredReadonlyStatus !== currentTextBox.attr('readonly')) {
                            currentTextBox.remove();
                            currentTextBox = $(currentTextBox.selector);
                        }
                    } 
                    
                    if (!currentTextBox.length){
                        if (isP5Prom){
                            currentTextBox = MDB.KendoConfigBuilder.gridTextBoxEditor(container, opts, {
                                'type': 'number',
                                'readonly': 'readonly'
                            });
                        } else{
                            currentTextBox = MDB.KendoConfigBuilder.gridTextBoxEditor(container, opts, { 'type': 'number' });
                            currentTextBox.on('change', function () {
                                model.set(opts.field, this.value); 
                            });
                        }
                    } 
                    
                    currentTextBox.val(model[opts.field]);

                    return;
                }

                model.set(opts.field, model[opts.field]);
                
                getCachedPromPrkeData(title, function (proms, prkesPerProm) {
                    var dataSource = isProm ? proms : prkesPerProm[model.BAN_P5_PROM_ID];
                    
                    //Most likely a PRKE field - no proms were selectable
                    if(!dataSource){
                        dataSource = [];
                    }
                    
                    if(isProm && model[opts.field] === null){
                        //Simply take the first value for convenience sake
                        //PRKE selectable values are dependant on PROM
                        //PROM needs to be set prior to loading PRKE datasource
                        model[opts.field] = dataSource[0];
                    }
                    
                    //Refresh datasources on title switch
                    if (currentDropdown.length){
                        currentDropdown.data('kendoDropDownList').dataSource.data(dataSource);
                        return;
                    }

                    //Protect against getting assigned PROM/PRKE values from other products
                    if(!dataSource.length){
                        model[opts.field] = null;
                    }
                    
                    var kConfig = {
                        dataSource: dataSource,
                        change: function () {
                            var newValue = this.value();
                            
                            model.set(opts.field, newValue);
                            
                            if (isProm){
                                var row = $('[data-uid="' + model.uid + '"]');
                                var prkeSelector = row.find('[data-container-for="BAN_P5_PRKE_ID"] select[name="BAN_P5_PRKE_ID"]');
                                var prkeSelectorKendoControl = prkeSelector.data('kendoDropDownList');
                                
                                //Change should also bubble to PRKE selector
                                prkeSelectorKendoControl.dataSource.data(prkesPerProm[newValue]);
                                prkeSelectorKendoControl.trigger('change');
                            }
                        },
                        dataBound: function(){
                            //Ensure the row has an actual value
                            //Mark the row as dirty to force kendo to post it upon saving
                            var value = this.value();
                            if(model[opts.field] === null){
                                model[opts.field] = value;
                                model.dirty = true;
                            }
                        }
                    };

                    if (!isProm) {
                        kConfig.filter = 'contains';
                        kConfig.dataTextField = 'DisplayText';
                        kConfig.dataValueField = 'PRKE';
                    }

                    currentDropdown = MDB.KendoConfigBuilder.gridDropdownEditor(container, opts.field, undefined, kConfig, opts);
                    currentDropdown.data('kendoDropDownList').value(model[opts.field]);

                    //Due to the asynchronous nature of kendo's renderers/ajax calls
                    //We also need to include this check here
                    if(model.UseAriaProductId){
                        container.children().hide();
                    } else{
                        container.children().show();
                    }
                });
            };
            
            var renderUseAriaPrkeEditor = function(container, opts){
                //When checked, we should hide the BAN P5 PROM/PRKE options and display the new ARIA Product dropdown
                //When unchecked, we should hide the ARIA Product dropdown, and display the BAN P5 PROM/PRKE options
                var checkbox = MDB.KendoConfigBuilder.gridCheckboxEditor(container, opts)
                    .find('[data-field="' + opts.field + '"]');

                //Ensure a uniform style
                checkbox.addClass('pull-left');
                
                var row = $('[data-uid="' + opts.model.uid + '"]');

                var onCheckedDisplayedContainers = row.find('[data-container-for="ARIA_PRODUCT_ID"]');
                var onCheckedHiddenContainers = row.find('[data-container-for="BAN_P5_PRKE_ID"],[data-container-for="BAN_P5_PROM_ID"],[data-container-for="CustomPromPrke"]');
                
                var toggleDependentFields = function(){
                    var checked = $(this).is(':checked');

                    //We only want to show/hide a container's children
                    //Hiding the containers causes the whole grid to spazz out
                    //The elements are only guaranteed to be available after all renderers have been invoked though
                    //Therefor we need to select the children of the containers each invocation 
                    var onCheckedDisplayedElements = onCheckedDisplayedContainers.children();
                    var onCheckedHiddenElements = onCheckedHiddenContainers.children();
                    
                    if(checked){
                        onCheckedDisplayedElements.show();
                        onCheckedHiddenElements.hide();
                    } else{
                        onCheckedDisplayedElements.hide();
                        onCheckedHiddenElements.show();
                    }
                };
                
                checkbox.on('change', toggleDependentFields);
                
                //Schedule invocation after the rest of the function queue has been processed
                //This should ensure all renderers have been properly invoked, making all necessary elements available
                setTimeout(function(){
                    toggleDependentFields.call(checkbox)
                }, 0);
            };
            
            var renderAriaProductIdEditor = function(container, opts){
                var title = opts.model.Title;
                
                var titleName = MDB.DPN.Offers.Settings.getTitleName(title);
                var dropdownOptions = _config.rowDropDowns.ARIA_PRODUCT_ID[titleName];

                renderDropdownEditor(container, opts, dropdownOptions);
            };
            
            var reloadAriaProductIdEditor = function(model){
                var titleName = MDB.DPN.Offers.Settings.getTitleName(model.Title);
                var dropdownOptions = _config.rowDropDowns.ARIA_PRODUCT_ID[titleName];

                reloadDropdownEditor(model, 'ARIA_PRODUCT_ID', dropdownOptions);
            };
            
            var renderPaymentMethodEditor = function(container, opts){
                renderDropdownEditor(container, opts, _config.rowDropDowns[opts.field]);
            };
            
            var renderDistributionMethodEditor = function(container, opts){
                renderDropdownEditor(container, opts, _config.rowDropDowns[opts.field]);
            };
            
            var toggleBabEditors = function(model){
                var babFields = ['DistributionMethod'];
                
                var row = $('[data-uid="' + model.uid + '"]');
                
                //Build a selector for our babfields
                //[data-container-for="..."],[data-container-for="..."]
                var selector = _.map(babFields, function(field) {
                    return '[data-container-for="' + field + '"] >' 
                }).join(',');
                var containers = row.find(selector);
                
                if(
                    MDB.DPN.Offers.Settings.isBabTitle(model.Title) ||
                    MDB.DPN.Offers.Settings.isBabMagTitle(model.Title)
                    
                ){
                    //Find our dropdowns, take map their values to the matching model columns
                    containers.find('select').each(function(){
                        model[this.name] = this.value; 
                    });
                    
                    containers.show();
                    return;
                }
                
                //Clear our values, hide the containers
                babFields.forEach(function(field){
                    model[field] = null; 
                });
                
                containers.hide();
            };
            
            var reloadBanP5PromPrkeEditors = function(model){
                var title = model.Title;

                var row = $('[data-uid="' + model.uid + '"]');
                var promContainer = row.find('[data-container-for="BAN_P5_PROM_ID"]');
                var prkeContainer = row.find('[data-container-for="BAN_P5_PRKE_ID"]');

                if (!model.CustomPromPrke){
                    if (!MDB.DPN.Offers.Settings.isP5Title(model.Title)){
                        promContainer.empty();
                    }
                    
                    prkeContainer.empty();   
                }
                
                getCachedPromPrkeData(title, function (proms) {
                    if ((!model.CustomPromPrke && proms.indexOf(model.BAN_P5_PROM_ID) === -1) || MDB.DPN.Offers.Settings.isP5Title(title)){
                        //Take default PROM
                        model.BAN_P5_PROM_ID = proms[0];
                    }

                    renderBanP5PromPrkeEditor(promContainer, {
                        field: 'BAN_P5_PROM_ID',
                        model: model
                    });
                    
                    renderBanP5PromPrkeEditor(prkeContainer, {
                        field: 'BAN_P5_PRKE_ID',
                        model: model
                    });
                });
            };
            
            banP5PromColumn.editor = renderBanP5PromPrkeEditor;
            banP5PrkeColumn.editor = renderBanP5PromPrkeEditor;
            useAriaPrkeColumn.editor = renderUseAriaPrkeEditor;
            ariaProductIdColumn.editor = renderAriaProductIdEditor;
            paymentMethodColumn.editor = renderPaymentMethodEditor;
            distributionMethodColumn.editor = renderDistributionMethodEditor;
            
            
            titleColumn.editor = function(container, opts) {
                var model = opts.model;
                
                //Force field value to be that of the selected title to correctly preselect a dropdown value
                model[opts.field] = MDB.DPN.Offers.Settings.getTitleId(model[opts.field]);
                
                MDB.KendoConfigBuilder.gridDropdownEditor(
                    container, 
                    opts.field,
                    //$(MDB.DPN.Offers.getTitleDropdownOptions()),
                    availableTitles,
                    {
                        change: function (e) {
                            var newTitle = this.value();
                            model.set(opts.field, newTitle);

                            reloadAriaProductIdEditor(model);
                            reloadBanP5PromPrkeEditors(model);
                            toggleBabEditors(model);
                        }
                    }, 
                    opts
                );
            };
            
            gridConfig.edit = function(e) {
                toggleBabEditors(e.model);

                e.container.find('[name="CustomPromPrke"]').on('change', function () {
                    reloadBanP5PromPrkeEditors(e.model);
                });
            };

            if (opts.deleteable) {
                var deleteCmd = MDB.KendoConfigBuilder.gridCustomDeleteCommand(
                    sprintf(MDB.loadResourceString('DataTable_DeletePrompt_TitleFormat') || '', ''),
                    sprintf(MDB.loadResourceString('DataTable_DeletePrompt_BodyFormat') || '', ''),
                    deleteProductsPerOfferUrl);
                
                gridConfig.columns[gridConfig.columns.length - 1].command.push(deleteCmd);
            }

            if (opts.isExpiredGrid) {
                gridConfig.columns[gridConfig.columns.length - 1].command.push(
                    {
                        text: MDB.loadResourceString('Button_Copy'),
                        click: function (e) {
                            e.preventDefault();
                            var id = parseInt(this.dataItem($(e.currentTarget).closest("tr")).id);
                            copyInvalidOffer(id);
                        }
                    }
                );
            }
        } // end if(editable)

        if (opts.gridConfig) {
            $.extend(gridConfig, opts.gridConfig);
        }

        return gridConfig;
    }

    function renderDropdownEditor (container, opts, dropdownOptions){
        var dropdown = MDB.KendoConfigBuilder.gridDropdownEditor(container, opts.field, undefined, {
            dataSource: {data: dropdownOptions},
            dataTextField: 'Text',
            dataValueField: 'Value',


            //For some reason kendo sets the entire dataSource record by as the model value by default
            //This happens even though the value() function does return the selected value
            //Setting the value manually is the easiest way to work around this
            change: function(){
                opts.model[opts.field] = this.value();
                opts.model.dirty = true;
            }
        }, opts);

        //Select our current value when necessary
        if(opts.model[opts.field]){
            dropdown.data('kendoDropDownList').value(opts.model[opts.field]);
        }
        
        opts.model[opts.field] = dropdown.val();
        
        return dropdown;
    }

    function reloadDropdownEditor (model, field, newOptions){
        var row = $('[data-uid="' + model.uid + '"]');
        var dropdown = row.find('[data-container-for="' + field + '"] select');
        var kDropdown = dropdown.data('kendoDropDownList');

        //Simply replacing the datasource should be enough
        kDropdown.setDataSource({data: newOptions});
        model[field] = kDropdown.value();
    };

    function copyInvalidOffer(id) {
        MDB.prompt(
            MDB.loadResourceString('Orders_Invalid_Copy_Title'),
            sprintf(MDB.loadResourceString('Orders_Invalid_Copy_Body'), name),
            function (ok) {
                if (ok) {
                    executeCopy(id);
                }
            }
        );
    }

    function executeCopy(id) {
        $.ajax({
            type: "GET",
            url: '/DPN/Offers/CopyInvalidOrder',
            data: { id: id },
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (data) {
                if (data.success === true) {
                    alert('success');
                    reloadGrids();
                }
            }
        });
    }
    
    function forAllProductsPerOfferGrids(callback){
        callback(activeOffers.data('kendoGrid'));
        callback(plannedOffers.data('kendoGrid'));
        callback(expiredOffers.data('kendoGrid'));
        callback(invalidOffers.data('kendoGrid'));
    }

    function reloadGrids() {
        forAllProductsPerOfferGrids(function(grid){
            grid.dataSource.read();
            grid.refresh();
        });
    }

    function createDataSource(opts) {
        var defaultTitle = opts.defaultTitle;
        var config = {
            transport: {
                read: function(options) {
                    var activeFromEndParam = opts.activeFromEnd ? opts.activeFromEnd.toISOString() : null;
                    var activeFromStartParam = opts.activeFromStart ? opts.activeFromStart.toISOString() : null;
                    var activeUntilParam = opts.activeUntil ? opts.activeUntil.toISOString() : null;
                    var isInvalidGrid = opts.isInvalidGrid ? opts.isInvalidGrid : false;
                    
                    var params = $.param({    
                        id: opts.id,
                        isActive: opts.isActive,
                        activeFromStart: activeFromStartParam,
                        activeFromEnd: activeFromEndParam,
                        activeUntil: activeUntilParam,
                        invalidRecords: isInvalidGrid
                    });
                    
                    var apUrl = crudServiceBaseUrl + '?' + params;
                    
                    MDB.KendoConfigBuilder.dataSourceTransportFunction(apUrl, 'GET', options);
                },
                update: function(options) {
                    if (opts.onChangeSuccess) {
                        var optionSuccess = options.success;
                        options.success = function(result) {
                            optionSuccess(result);
                            opts.onChangeSuccess(result);
                        };
                    }

                    MDB.KendoConfigBuilder.dataSourceTransportFunction(crudServiceBaseUrl, 'PUT', options);
                }
            },
            pageSize: 20,
            schema: {
                model: {
                    id: 'Id',
                    fields: {
                        Id: { editable: false, type: 'number' },
                        PRKE: { editable: false, type: 'number', defaultValue: opts.id },
                        PROM: { editable: false, type: 'number' },
                        Title: { defaultValue: defaultTitle },
                        BAN_P5_PROM_ID: { type: 'number', editable: !opts.restrictEdit },
                        BAN_P5_PRKE_ID: { type: 'number', editable: !opts.restrictEdit },
                        UseAriaProductId: { type: 'boolean', editable: !opts.restrictEdit },
                        ARIA_PRODUCT_ID: { editable: !opts.restrictEdit },
                        PaymentMethod: { editable: !opts.restrictEdit },
                        DistributionMethod: {editable: !opts.restrictEdit},
                        Description: { editable: false },
                        ExtraDescription: { editable: false },
                        ProductPrice: { 
                            editable: false, 
                            type: 'number',
                            defaultValue: null
                        },
                        ActiveFrom: { type: 'date', editable: true },
                        ActiveUntil: {
                            type: 'date',
                            defaultValue: new Date(2099, 11, 31),
                            editable: true
                        },
                        Labels: { },
                        CustomPromPrke: { type: 'boolean', defaultValue: false, editable: !opts.restrictEdit },
                        IsActive: { type: 'boolean', defaultValue: true, editable: !opts.restrictEdit },
                        IsInvalid: { type: 'boolean', defaultValue: false, editable: userHasViewInvalidPermission },
                        AantalLeveringen: { type: 'number', defaultValue: null, editable: !opts.restrictEdit },
                        Wbs: { editable: !opts.restrictEdit },
                        SalesPromotion: { editable: !opts.restrictEdit }
                    }
                }
            },
            error: function(e) {
                this.cancelChanges();
                alert(MDB.KendoConfigBuilder.getWebApiErrorsMessage(e));
            }
        };

        if (opts.editable) {
            config.transport.create = function(options) {
                if (opts.onChangeSuccess) {
                    var optionSuccess = options.success;
                    options.success = function(result) {
                        optionSuccess(result);
                        opts.onChangeSuccess(result);
                    };
                }

                MDB.KendoConfigBuilder.dataSourceTransportFunction(crudServiceBaseUrl, 'POST', options);
            };
        }
        return new kendo.data.DataSource(config);
    }

    function getPromPrkeData(productId, callback) {
        return $.ajax({
            url: promPrkeCrudServiceUrl,
            data: { productId: productId },
            success: function(data) {
                data = data.data;

                var proms = [];
                var dataPerProm = {};

                data.forEach(function(d) {
                    if (proms.indexOf(d.PROM) === -1) {
                        proms.push(d.PROM);
                        dataPerProm[d.PROM] = [];
                    }

                    dataPerProm[d.PROM].push({
                        PRKE: d.PRKE,
                        DisplayText: d.PRKE + ': ' + d.Promotie + ' ' + d.KenmerkOmschrijving
                    });
                });

                callback(proms, dataPerProm);
            }
        });
    }
})(jQuery);